import React, { useEffect, useState } from "react";
import { ArrowLeftShort, WindowX } from "react-bootstrap-icons";
import { Link, useSearchParams } from "react-router-dom";
import { useLinkedInLoginMutation } from "../../helper/auth/login-api";
import { setCookie } from "../../utils/cookies";

function LinkedinCallback() {
  const [params] = useSearchParams();

  // const [claimsInfo, setClaimsInfo] = useState("claim info not received");
  // const [greeting, setGreeting] = useState("not logged in");
  // const [userinfo, setUserInfo] = useState("user info not set");
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [linkedinLogin] = useLinkedInLoginMutation();

  const code = params.get("code");
  useEffect(() => {
    const loginWithLinkedIn = async () => {
      const data = await linkedinLogin({ code });
      console.log(data);
      if (!data) {
        setLoading(false);
        return;
      }
      if (data?.error || !data?.data?.authToken) {
        setLoading(false);
        setIsLoggedIn(false);
        return;
      }
      setIsLoggedIn(true);
      setLoading(false);
      setUserName(data?.data?.fullName);
      setCookie("token", data?.data.authToken, { expires: 7, secure: true });
      localStorage.setItem("isValidUser", true);
      localStorage.setItem("userData", JSON.stringify(data?.data));
      window.location.href = "/";
    };

    console.log(code);
    if (code) loginWithLinkedIn(code);
  }, [params]);

  return (
    <div className="text-center d-flex align-items-center justify-content-center flex-column h-100">
      {loading ? (
        <>
          <span className="register-loader position-relative d-block mb-5 position-fixed" />
          <p>Please wait...</p>
        </>
      ) : (
        <>
          {isLoggedIn ? (
            <>
              <span className="register-loader position-relative d-block mb-5" />
              <h5 className="theme-text text-capitalize">Hi {userName},</h5>
              <p>Please wait until we navigate you...</p>
            </>
          ) : (
            <>
              <WindowX className="display-1 text-danger" />
              <h2 className="text-danger text-capitalize mb-0 mt-3">
                login failed!
              </h2>
              <p>Please try after sometime.</p>
              <a href={"/login"} className="link-offset-1">
                <ArrowLeftShort className="fs-3 " /> Back to Login Page.
              </a>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default LinkedinCallback;
